import React from 'react';
import { Link } from 'react-router';
import { IntercomAPI } from 'react-intercom';
import styles from './styles.scss';

function HomeFooter() {
  return (
    <div className={styles.container}>
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="row">
            <div className="col-sm-12 text-center mt100">
              <h1>Projects start Jan. 16th. Ready?</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 col-md-8 col-sm-9 col-center col-xs-12 mt50 mb100">
              <div className="row">
                <div className="col-sm-5 col-sm-offset-1">
                  <Link to={{ pathname: '/startup-application'}} className="btn btn-dc-blue btn-block">
                    APPLY NOW
                  </Link>
                </div>
                <div className="col-sm-5">
                  <a className="btn btn-dc-transparent btn-block" onClick={() => IntercomAPI('show')}>
                    CHAT WITH US
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFooter;



// WEBPACK FOOTER //
// ./src/components/StartupFooter/index.js